import { RadioGroup } from '@headlessui/react'
import { classNames } from '@progress/kendo-react-common'
import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { useAuth } from 'context/AuthContext'
import { useTenantContext } from 'context/TenantContext'
import React, { useEffect, useState } from 'react'
import {
    DEFAULT_LOCATION,
} from 'types/membership'
import { useFetch } from 'utils/fetch-helper'
import { FetchMethods } from 'utils/types'
import { ICouponModal } from '.'
import SelectServices from '../Membership/SelectServices'
import { ModalDataAttributes } from '../types'

export const REDEMPTION_LIST = [ //TODO: refactor
    { id: 1, value: 'SERVICE', label: 'Services' },
    { id: 2, value: 'MEMBERSHIP', label: 'Memberships' },
    // { id: 3, value: 'PRODUCTS', label: 'Products' },
]

const RedemptionInfo: React.FC<ICouponModal> = ({
    isDirty,
    setIsDirty,
}) => {
    const { CreateCouponModal } = useAuth()
    const { tenant } = useTenantContext()

    const { translations } = useAppContext()
    const { attributes, setAttributes } = CreateCouponModal
    const [fatal_message, setFatalMessage] = useState('')

    useEffect(() => {
        if (!attributes?.redemptionType) {
            setAttributes({ ...attributes, redemptionType: (attributes?.membership_ids as string[])?.length > 0 ? 'MEMBERSHIP' : 'SERVICE'  })
        }
    }, [])

    const {
        data: categories,
        status: categories_api_status,
        doFetch: getCategories,
    } = useFetch(
        `/v1/categories/by-type?type=${attributes?.redemptionType}&tenantId=${tenant?.id}`,
        FetchMethods.GET
    )

    const { //TODO: remove
        data: locations,
        status: locations_api_status,
        doFetch: getLocations,
    } = useFetch(
        `/v1/locations/tenant-id?tenantId=${tenant?.id}&isDeleted=false`,
        FetchMethods.GET,
        false
    )

    const { //TODO: remove
        data: services,
        status: services_api_status,
        doFetch: getServices,
    } = useFetch(
        `/v1/services?tenantId=${tenant?.id}&isDeleted=false&size=999`,
        FetchMethods.GET,
        attributes?.rededemptionType === 'SERVICE'
    )

    const { //TODO: remove
        data: memberships,
        status: memberships_api_status,
    } = useFetch(
        `/v1/memberships/by-tenant-id?tenantId=${tenant?.id}`,
        FetchMethods.GET,
        attributes?.redemptionType === 'MEMBERSHIP'
    )

    useEffect(() => {
        getLocations()
        getCategories()
        getServices()
    }, [attributes?.redemptionType, CreateCouponModal.is_open])

    useEffect(() => {
        if (services_api_status == 200 || memberships_api_status == 200) {
            if (services?.content?.length == 0) {
                setFatalMessage(
                    `No Service has been created yet. Please create one.`
                )
            } else {
                const list: any[] =
                    attributes?.redemptionType === 'MEMBERSHIP'
                        ? !!memberships?.length
                            ? memberships
                            : []
                        : services?.content

                let fetched_services = list?.map(
                    (service: Record<string, string>) => {
                        return service
                    }
                )
                setAttributes({
                    ...attributes,
                    services: fetched_services,
                })
            }
        }
    }, [services, services_api_status, memberships, memberships_api_status])

    useEffect(() => {
        if (
            categories_api_status == 200 &&
            categories.content &&
            categories.content.length > 0
        ) {
            let fetched_categories = categories.content.map(
                (category: Record<string, string>) => {
                    return {
                        text: category.name,
                        value: category.id,
                    }
                }
            )
            setAttributes({
                ...attributes,
                membership_categories: fetched_categories,
            })
        }
    }, [categories, categories_api_status, attributes?.redemptionType])

    useEffect(() => {
        if (locations_api_status == 200) {
            if (locations.content.length == 0) {
                setFatalMessage(
                    'No Location has been created yet. Please create one.'
                )
            } else {
                let fetched_locations = locations.content.map(
                    (location: Record<string, string>) => {
                        return {
                            text: location.name,
                            value: location.id,
                        }
                    }
                )
                fetched_locations.unshift(DEFAULT_LOCATION)

                let location = DEFAULT_LOCATION as ModalDataAttributes
                if (attributes?.location_ids) {
                    let location_ids: string[] =
                        attributes?.location_ids as string[]
                    location = fetched_locations.find(
                        (l: Record<string, string>) =>
                            l.value == location_ids[0]
                    ) as ModalDataAttributes
                }

                setAttributes({
                    ...attributes,
                    location,
                    locations: fetched_locations,
                })
            }
        }
    }, [locations, locations_api_status])

    const renderRadioButtons = () => (
        <div className="">
            <RadioGroup
                value={attributes?.service_type}
                onChange={(v) => {
                    setAttributes({
                        ...attributes,
                        redemptionType: v as string,
                    })
                }}
            >
                <RadioGroup.Label
                    className={classNames('text-lg block mb-3')}
                >
                    <Translation
                        content_key="select_redemption_type"
                        translations={translations}
                    />
                </RadioGroup.Label>
                <div className="flex gap-6">
                    {REDEMPTION_LIST.map((v, idx) => {
                        const selected =
                            attributes?.redemptionType === v.value
                        return (
                            <RadioGroup.Option key={idx} value={v.value}>
                                {({ checked }) => (
                                    <div className="flex items-center gap-2 text-base cursor-pointer">
                                        <div
                                            className={classNames(
                                                selected
                                                    ? 'border-primary-light'
                                                    : 'border-gray-400',
                                                'rounded-full w-6 h-6 border-2 flex items-center'
                                            )}
                                        >
                                            <i
                                                className={classNames(
                                                    selected
                                                        ? 'bg-primary-light'
                                                        : '',
                                                    'rounded-full w-4 h-4 block m-auto'
                                                )}
                                            />
                                        </div>
                                        <span
                                            className={
                                                checked
                                                    ? 'text-primary-light'
                                                    : ''
                                            }
                                        >
                                            {v.label}
                                        </span>
                                    </div>
                                )}
                            </RadioGroup.Option>
                        )
                    })}
                </div>
            </RadioGroup>
        </div>
    )

    return (
        <div>
            {renderRadioButtons()}
            <div className="mt-10">
                <SelectServices
                    displayFooter={false}
                    attributes={attributes}
                    setAttributes={setAttributes}
                    isDirty={isDirty}
                    setIsDirty={setIsDirty}
                    translations={translations}
                    onCancel={() => {}}
                    onPrevious={() => {}}
                    onNext={() => {}}
                    mainHeading={translations['coupon_redemption_heading']}
                    type={attributes?.redemptionType as string}
                />
            </div>
        </div>
    )
}

export default RedemptionInfo
